export enum DropdownThemes {
  DARK = 'dark',
  LIGHT = 'light',
}

export interface DropdownOption {
  value: string;
  label: string;
}
